module.exports = __webpack_public_path__ + "static/planeta_nosotras-a8aa28daec88019993308658ca6083b8.webp";